import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import RenderField from '../../FormTemplate/InputControl';
import RenderTextArea from '../../FormTemplate/TextareaControl';
import SelectAsync from '../../FormTemplate/SelectAsync';
import Select from '../../FormTemplate/Select';
import { Button } from 'react-bootstrap';

class NewProductSubForm extends React.Component {
   render() {
      const { handleSubmit, saveSubProduct, submitting, pristine, invalid } = this.props;
      return (
         <form noValidate autoComplete="off" onSubmit={handleSubmit(saveSubProduct)} >
            <Field name="item_id" component={SelectAsync} link="items/findProductByName" type="text"
                   label="Main Product" />
            <Field name="sub_item_variant" component={RenderField} type="text" label="Sub Product Variant" />
            <Field name="barcode" component={RenderField} type="text" label="Barcode" />
            <Field name="description" component={RenderTextArea} label="Product Description" />
            <Field name="active" component={Select}
                   options={[{ value: 1, label: "Active" }, { value: 0, label: "In Active" }]}
                   label="Active / InActive" />

            <Button type="submit" bsStyle="success" block disabled={submitting || pristine || invalid} >Save</Button >
         </form >
      );
   }
}

NewProductSubForm.propTypes = {
   saveSubProduct: PropTypes.func.isRequired,
   handleSubmit: PropTypes.func,
   submitting: PropTypes.boolean,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
};

export default reduxForm({
   form: 'itemNewProductSubForm',
   initialValues: {
      active: 1,
   }
})(NewProductSubForm);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/NewProductSubForm.js
 **/